var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33369 7.89507C7.19537 8.03338 7.19537 8.25763 7.33369 8.39594L11.7912 12.8534C12.0143 13.0765 12.3958 12.9185 12.3958 12.603V3.68804C12.3958 3.37251 12.0143 3.2145 11.7912 3.43761L7.33369 7.89507Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95825 3.18717C4.95825 2.99157 5.11682 2.83301 5.31242 2.83301H6.02075C6.21635 2.83301 6.37492 2.99157 6.37492 3.18717V13.1038C6.37492 13.2994 6.21635 13.458 6.02075 13.458H5.31242C5.11682 13.458 4.95825 13.2994 4.95825 13.1038V3.18717Z",
    fill: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipPrev);
export default __webpack_public_path__ + "static/media/skip_prev.a8fb083d6444de52a1614866643215b6.svg";
export { ForwardRef as ReactComponent };